const REPORT_TYPES_1099 = ['attorney', 'medical', 'other'] as const;

export default REPORT_TYPES_1099;
